
import React, {FC} from 'react';
import {BarColors} from 'templates/reports/colors';

import Group from './Group';

import * as styles from './styles.module.scss';

export const MeasureTypes: FC = () => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				Measurement types
			</div>
			<div className={styles.groups}>
				<Group
					color={BarColors.green}
					text='Estimated RMR'
					subtext='Based on equations using fat-free mass'
				/>
			</div>
		</div>
	);
};
